import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ea76a96c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ea76a96c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea76a96c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea76a96c')) {
      api.createRecord('ea76a96c', component.options)
    } else {
      api.reload('ea76a96c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ea76a96c&scoped=true", function () {
      api.rerender('ea76a96c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerClaimsManage/index.vue"
export default component.exports